__turbopack_context__.v({
  "buttons-container": "dqpAccountDetails-module-scss-module__ue6FwG__buttons-container",
  "buttons-container--editing": "dqpAccountDetails-module-scss-module__ue6FwG__buttons-container--editing",
  "buttons-wrapper": "dqpAccountDetails-module-scss-module__ue6FwG__buttons-wrapper",
  "cancel-button": "dqpAccountDetails-module-scss-module__ue6FwG__cancel-button",
  "edit-icon": "dqpAccountDetails-module-scss-module__ue6FwG__edit-icon",
  "edit-icon-error": "dqpAccountDetails-module-scss-module__ue6FwG__edit-icon-error",
  "form-field": "dqpAccountDetails-module-scss-module__ue6FwG__form-field",
  "grid": "dqpAccountDetails-module-scss-module__ue6FwG__grid",
  "grid--frozen": "dqpAccountDetails-module-scss-module__ue6FwG__grid--frozen",
  "icon": "dqpAccountDetails-module-scss-module__ue6FwG__icon",
  "icon-not-verified": "dqpAccountDetails-module-scss-module__ue6FwG__icon-not-verified",
  "icon-verified": "dqpAccountDetails-module-scss-module__ue6FwG__icon-verified",
  "phone-container": "dqpAccountDetails-module-scss-module__ue6FwG__phone-container",
  "phone-input-input": "dqpAccountDetails-module-scss-module__ue6FwG__phone-input-input",
  "phoneinput": "dqpAccountDetails-module-scss-module__ue6FwG__phoneinput",
  "phoneinput-disabled": "dqpAccountDetails-module-scss-module__ue6FwG__phoneinput-disabled",
  "radio-buttons-container": "dqpAccountDetails-module-scss-module__ue6FwG__radio-buttons-container",
  "radio-buttons-padding": "dqpAccountDetails-module-scss-module__ue6FwG__radio-buttons-padding",
  "status": "dqpAccountDetails-module-scss-module__ue6FwG__status",
  "text": "dqpAccountDetails-module-scss-module__ue6FwG__text",
  "text-not-verified": "dqpAccountDetails-module-scss-module__ue6FwG__text-not-verified",
  "text-row": "dqpAccountDetails-module-scss-module__ue6FwG__text-row",
  "text-verified": "dqpAccountDetails-module-scss-module__ue6FwG__text-verified",
  "text-width": "dqpAccountDetails-module-scss-module__ue6FwG__text-width",
});
